/**
 * types.tsx
 *
 * Forked from reactabular-table version 8.14.0
 * https://github.com/reactabular/reactabular/tree/v8.14.0/packages/reactabular-table/src
 */
// Table Defaults
export const TableDefaults = {
    renderers: {
        table: 'table',
        header: {
            wrapper: 'thead',
            row: 'tr',
            cell: 'th'
        },
        body: {
            wrapper: 'tbody',
            row: 'tr',
            cell: 'td'
        }
    }
};
//# sourceMappingURL=types.js.map